/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionClickDateGroupingFromJSON, ApiAttributionClickDateGroupingToJSON, } from './ApiAttributionClickDateGrouping';
import { ApiCSVUploadSessionFromJSON, ApiCSVUploadSessionToJSON, } from './ApiCSVUploadSession';
import { ApiProductTaggerUniqueFieldFromJSON, ApiProductTaggerUniqueFieldToJSON, } from './ApiProductTaggerUniqueField';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiProfitMarginFromJSON(json) {
    return ApiProfitMarginFromJSONTyped(json, false);
}
export function ApiProfitMarginFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cost': !exists(json, 'cost') ? undefined : json['cost'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'dateGrouping': !exists(json, 'dateGrouping') ? undefined : ApiAttributionClickDateGroupingFromJSON(json['dateGrouping']),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'percentage': !exists(json, 'percentage') ? undefined : json['percentage'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'uniqueField': !exists(json, 'uniqueField') ? undefined : ApiProductTaggerUniqueFieldFromJSON(json['uniqueField']),
        'uniqueValue': !exists(json, 'uniqueValue') ? undefined : json['uniqueValue'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'uploadSession': !exists(json, 'uploadSession') ? undefined : ApiCSVUploadSessionFromJSON(json['uploadSession']),
    };
}
export function ApiProfitMarginToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cost': value.cost,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'dateGrouping': ApiAttributionClickDateGroupingToJSON(value.dateGrouping),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'id': value.id,
        'percentage': value.percentage,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'uniqueField': ApiProductTaggerUniqueFieldToJSON(value.uniqueField),
        'uniqueValue': value.uniqueValue,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'uploadSession': ApiCSVUploadSessionToJSON(value.uploadSession),
    };
}
